// Cascaders.jsx
import React, { useState } from 'react';
import Classification from './Classification';
import Grade from './Grade';
import Optional from './Optional';
import ApplicationBatch from './ApplicationBatch';
import Volunteer from './Volunteer';
import PreferredRegions from './PreferredRegions';
import PreferredMajor from './PreferredMajor';
import GraduationIntention from './GraduationIntention';
import { CloseOutlined } from '@ant-design/icons';
import fieldCategoryStore from '@/components/field-category/store';
import GaokaoxkStore from './GaokaoxkStore';
import Optional2 from './Optional2';
import { observer } from 'mobx-react-lite';

function Cascaders(props) {
    let { isRightAligned = true } = props;
    const [areaName, setAreaName] = useState(['北京', '本科批']);
    

    const twoAreas = [
        '安徽',
        '重庆',
        '福建',
        '甘肃',
        '广东',
        '广西',
        '贵州',
        '黑龙江',
        '河北',
        '河南',
        '湖北',
        '湖南',
        '江苏',
        '江西',
        '吉林',
        '辽宁',
        '内蒙古',
        '宁夏',
        '青海',
        '山西',
        '陕西',
        '四川',
        '云南',
    ];
    const closeButtonClass = isRightAligned
        ? "right-1"
        : "right-[-9rem]";

    return (
        <div className="relative max-w-full">

            <div className="space-y-3">
                {/* 必填部分 - 使用网格布局确保标签与第一行对齐 */}
                <div className="grid grid-cols-[auto_1fr] gap-4 items-start">
                    {/* 标签容器 - 添加固定高度和顶部微调 */}
                    <div className="h-[30px] flex items-center justify-start pt-[3px]">
                        {/* 固定高度标签 - 使用固定高度24px */}
                        <div className="min-w-[40px] w-auto px-2 h-[24px] flex items-center justify-center rounded-full bg-gradient-to-r from-blue-600 to-blue-400 text-white text-xs font-medium whitespace-nowrap">
                            必填
                        </div>
                    </div>
                    
                    {/* 内容区域 */}
                    <div className="flex flex-wrap gap-3 items-center">
                        <Classification setAreaName={setAreaName} />
                        <Grade areaName={GaokaoxkStore.requiredFields.classification} />
                        {twoAreas.includes(
                            GaokaoxkStore.requiredFields.classification[0]
                        ) ? (
                            <Optional2
                                areaName={GaokaoxkStore.requiredFields.classification[0]}
                            />
                        ) : (
                            <Optional
                                areaName={GaokaoxkStore.requiredFields.classification[0]}
                            />
                        )}
                        <Volunteer />
                    </div>
                </div>

                {/* 选填部分 - 使用相同的网格布局 */}
                <div className="grid grid-cols-[auto_1fr] gap-4 items-start">
                    {/* 标签容器 - 与必填部分相同的结构 */}
                    <div className="h-[30px] flex items-center justify-start pt-[3px]">
                        {/* 固定高度标签 - 使用相同的高度24px */}
                        <div className="min-w-[40px] w-auto px-2 h-[24px] flex items-center justify-center rounded-full border border-blue-500 text-blue-600 text-xs font-medium whitespace-nowrap">
                            选填
                        </div>
                    </div>
                    
                    {/* 内容区域 */}
                    <div className="flex flex-wrap gap-2 items-center">
                        <div className="text-gray-700 whitespace-nowrap">我想在</div>
                        <PreferredRegions />
                        <div className="text-gray-700 whitespace-nowrap">上大学，想学</div>
                        <PreferredMajor />
                        <div className="text-gray-700 whitespace-nowrap">，未来选择</div>
                        <GraduationIntention />
                    </div>
                </div>
                
                <div className='pb-[12px] text-[#000000]'>请根据以上信息为我推荐学校和专业，生成志愿表</div>
            </div>
        </div>
    );
}

export default observer(Cascaders);